export default "__VITE_ASSET__KLSfrA3W__"